import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '@/locales/en';
import ru from '@/locales/ru';
import { SUPPORTED_LANGUAGES, resolveInitialLanguage } from '@/utils/language';

i18n.use(initReactI18next).init({
	resources: { en, ru },
	lng: resolveInitialLanguage(),
	fallbackLng: 'ru',
	/* Страховка от вызова changeLanguage с неизвестным кодом. Отбрасывать
	   регион у ru-RU здесь не нужно: это делает resolveInitialLanguage, и
	   второй механизм развёл бы два места, решающих один вопрос. */
	supportedLngs: [...SUPPORTED_LANGUAGES],
	interpolation: { escapeValue: false },
	defaultNS: 'common',
});

export default i18n;
